import React from "react";

const KvkkModal = ({ isOpen, kvkkMetni, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal"
      id="kvkk-modal"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1050,
      }}
    >
      <div className="t-modalAreaMailOrder" id="id-modal" style={{ display: "block" }}>
        <div
          className="t-modalContentMailOrder"
          id="id-modalTipi"
          style={window.innerWidth <= 900 ? { width: "89%" } : { width: "51%" }}
        >
          <div
            className="t-modalMailOrder"
            id="id-modalGenel"
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              boxShadow: "3px 3px 3px #939191",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <div className="container-fluid">
              {/* Header */}
              <div className="row t-modalHeaderMailOrder align-items-center">
                <div
                  className="col"
                  id="id-modalHeader"
                  style={{ color: "rgb(119, 119, 119)", fontWeight: "bold" }}
                >
                  KİŞİSEL VERİLERİN KORUNMASI KANUNU HAKKINDA BİLGİLENDİRME
                </div>
                <div
                  className="col-auto t-cursorPointer"
                  onClick={onClose}
                  style={{ cursor: "pointer" }}
                >
                  <i
                    className="t-icon-cross"
                    id="id-modalHeaderIcon"
                    style={{ color: "rgb(119, 119, 119)", fontSize: "18px" }}
                  ></i>
                </div>
              </div>

              {/* Body */}
              <div className="row t-modalBodyMailOrder">
                <div
                  className="col-12"
                  id="id-modalBody"
                  style={{
                    color: "rgb(119, 119, 119)",
                    fontSize: "12pt",
                    overflowY: "hidden",
                  }}
                  dangerouslySetInnerHTML={{ __html: kvkkMetni }}
                ></div>
              </div>

              {/* Footer */}
              <div className="row t-modalFooterMailOrder mt-3">
                <div className="col-12 text-end">
                  <button className="btn btn-secondary" onClick={onClose}>
                    Kapat
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KvkkModal;
